@if (isEdit()) {
  <h2 mat-dialog-title>Edit Owner</h2>
} @else {
  <h2 mat-dialog-title>Add Owner</h2>
}

<mat-dialog-content>
  <form id="owner-form" [formGroup]="ownerForm" (ngSubmit)="submit()">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Location</mat-label>
        <input matInput formControlName="location" />
      </mat-form-field>
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-flat-button
    type="submit"
    form="owner-form"
    [disabled]="ownerForm.pristine || !ownerForm.valid"
  >
    Save
  </button>
  <button mat-button type="button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
